var TorsoFormView = require('backbone-torso/modules/FormView');
var eregAppointmentSelectWorkflowTemplate = require('./eregAppointmentSelectWorkflowTemplate.hbs');
var demographicsFeatureConfigModel = require('./../../demographics/demographicsFeatureConfigModel');
var insuranceFeatureConfigModel = require('./../../appointment-insurance/insuranceFeatureConfigModel');
var questionnaireFeatureConfigModel = require('./../../questionnaire/questionnaireFeatureConfigModel');
var financialFeatureConfigModel = require('./../../financial/financialFeatureConfigModel');
var formFeatureConfigModel = require('./../../form/formFeatureConfigModel');
var workflowNodes = require('./../utils/workflowNodes');
var appointmentConfigurationModel = require('./../../appointment-config/appointmentConfigurationModel');

var AppointmentTypeParentBehavior = require('./../../behaviors/AppointmentTypeParentBehavior');
var AppointmentTypeDataBehavior = require('./../../appointment-type/AppointmentTypeDataBehavior');

var _ = require('underscore');

module.exports = TorsoFormView.extend({
  template: eregAppointmentSelectWorkflowTemplate,
  tagName: 'section',

  behaviors: {
    appointmentTypeParentBehavior: {
      behavior: AppointmentTypeParentBehavior,
      renderOnParentFetched: false
    },
    appointmentType: {
      behavior: AppointmentTypeDataBehavior,
      ids: {property: 'view:appointmentTypeExternalIds'}
    },
    parentAppointmentType: {
      behavior: AppointmentTypeDataBehavior,
      ids: {property: 'behaviors.appointmentType.data:parentExternalId'}
    },
    grandparentAppointmentType: {
      behavior: AppointmentTypeDataBehavior,
      ids: {property: 'behaviors.parentAppointmentType.data:parentExternalId'}
    }
  },

  /**
   * @method initialize
   * @override
   */
  initialize: function() {
    _.bindAll(this, '_setAppointmentFeatureConfigsToModel', '_setFeatureConfigsToModel');
    this.listenTo(this.model, 'change', this.render);
    this.listenTo(this.getBehavior('appointmentType'), 'change:parent', this._setAppointmentFeatureConfigsToModel);
    this.listenTo(this.getBehavior('parentAppointmentType'), 'change:parent', this._setAppointmentFeatureConfigsToModel);
    this._fetchFeatureConfigs();
  },

  /**
   * @method prepare
   * @override
   */
  prepare : function() {
    var context = {};
    context.isAllFeatureConfigsFetched = this._isAllFeatureConfigsFetched();
    if (context.isAllFeatureConfigsFetched) {
      _.extend(context, this._getFeatureConfigs());
      _.extend(context, this._getAppointmentEnabledWizardSteps());
    }
    return context;
  },

  /**
   * Fetch all workflow feature configs
   * @method _fetchFeatureConfigs
   * @private
   * @return {Deferred} a promise the will resolve after all workflow feature configs are fetched
   */
  _fetchFeatureConfigs: function() {
    $.when(
      demographicsFeatureConfigModel.loadOnce(),
      insuranceFeatureConfigModel.loadOnce(),
      questionnaireFeatureConfigModel.loadOnce(),
      formFeatureConfigModel.loadOnce(),
      financialFeatureConfigModel.loadOnce(),
      appointmentConfigurationModel.loadOnce()
    ).done(this._setFeatureConfigsToModel);
  },

  /**
   * Set client level workflow feature configs to model
   * @method _setFeatureConfigsToModel
   * @private
   */
  _setFeatureConfigsToModel: function() {
    this.model.set(this._getFeatureConfigs());
  },

  /**
   * Set appointment level feature configs and workflow nodes all checked config to model
   * @method _setAppointmentFeatureConfigsToModel
   * @private
   */
  _setAppointmentFeatureConfigsToModel: function() {
    this.model.set(this._getAppointmentEnabledWizardSteps());
    this.model.set(this._getWorkflowNodesAllCheckedConfig());
  },

  /**
   * @method _isAllFeatureConfigsFetched
   * @private
   * @return {Boolean} true if all feature configs including client and appointment level configs have been fetched
   */
  _isAllFeatureConfigsFetched: function() {
    return demographicsFeatureConfigModel.loadedOnce
      && insuranceFeatureConfigModel.loadedOnce
      && financialFeatureConfigModel.loadedOnce
      && questionnaireFeatureConfigModel.loadedOnce
      && formFeatureConfigModel.loadedOnce
      && appointmentConfigurationModel.loadedOnce
      && this._getEffectiveEnabledWizardSteps();
  },

  /**
   * @method _getEffectiveEnabledWizardSteps
   * @return {Object} the effective wizard steps across all appt types.
   * @private
   */
  _getEffectiveEnabledWizardSteps: function() {
    var appointmentTypeModels = this.getBehavior('appointmentType').data.getModels();
    if (appointmentTypeModels && appointmentTypeModels.length > 0) {
      return _.chain(appointmentTypeModels)
        .map(function(appointmentTypeModel) {
          return appointmentTypeModel.getEffectiveEnabledWizardSteps();
        })
        .flatten()
        .uniq()
        .value();
    } else {
      return [];
    }
  },

  /**
   * Get simplified feature configs from all feature config models
   * @method _getFeatureConfigs
   * @private
   * @return {Object} a map from workflow nodes to their availability on client level
   */
  _getFeatureConfigs: function() {
    return {
      demographicsEnabledOnClient: demographicsFeatureConfigModel.isEnabledNormalLevel(),
      insuranceEnabledOnClient: insuranceFeatureConfigModel.isEnabledNormalLevel(),
      financialEnabledOnClient: financialFeatureConfigModel.isEnabledNormalLevel(),
      questionnaireEnabledOnClient: questionnaireFeatureConfigModel.isEnabledNormalLevel(),
      formEnabledOnClient: formFeatureConfigModel.isEnabledNormalLevel() && !appointmentConfigurationModel.get('allowMultipleAppointmentsRegistration'),
      isMultiApptsEnabled: appointmentConfigurationModel.get('allowMultipleAppointmentsRegistration')
    };
  },

  /**
   * Get simplified appointment enabled wizard steps
   * @method _getAppointmentEnabledWizardSteps
   * @private
   * @return {Object} a map from workflow nodes to their availability on appointment level
   */
  _getAppointmentEnabledWizardSteps: function() {
    var appointmentEnabledWizardSteps = {};
    var enabledWizardSteps = this._getEffectiveEnabledWizardSteps();
    var nodeNames = _.keys(workflowNodes);
    if (enabledWizardSteps) {
      _.each(nodeNames, function(workflowNode) {
        var wizardStep = workflowNodes[workflowNode];
        appointmentEnabledWizardSteps[workflowNode + 'EnabledOnAppointment'] = enabledWizardSteps.indexOf(wizardStep) > -1;
      });
    }
    return appointmentEnabledWizardSteps;
  },

  /**
   * Get the workflow nodes all checked config
   * @method _getWorkflowNodesAllCheckedConfig
   * @private
   * @return {Object} a map from workflow nodes to their availability (true) on visit level
   */
  _getWorkflowNodesAllCheckedConfig: function() {
    var workflowNodesChecked = {};
    _.each(_.keys(workflowNodes), function(workflowNode) {
      workflowNodesChecked[workflowNode + 'Checked'] = true;
    });
    return workflowNodesChecked;
  }
});
